'use strict';

const $ = window.jQuery;
import ClipboardJS from 'clipboard';

export default class ArchiveFAQ {
    constructor() {
        if ( $('body').hasClass('post-type-archive-faq') ) {
            $(document).on({
                'facetwp-loaded': function() {
                    const clipboard = new ClipboardJS('.accordion__link');

                    $('.accordion__link__tooltip--success').hide();

                    clipboard.on('success', function(e) {
                        $('.accordion__link__tooltip').hide();
                        $('.accordion__link__tooltip--success').show();

                        setTimeout( function() {
                            $('.accordion__link__tooltip').show();
                            $('.accordion__link__tooltip--success').hide();
                        }, 1000);
                    });
                }
            });
        }
    }
}
